import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import clsx from 'clsx';
import { addOpacity } from 'lib/helpers';
import { LineIcon } from 'lib/LineIcon';

const PREFIX = 'ActionItem';

const classes = {
    title: `${PREFIX}title`,
    clickable: `${PREFIX}clickable`,
    subtitle: `${PREFIX}subtitle`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `1px solid ${addOpacity(theme.palette.text.primary, 0.1)}`,
    [`& .${classes.title}`]: {
        fontSize: theme.spacing(2)
    },

    [`&.${classes.clickable}`]: {
        cursor: 'pointer'
    },

    [`& .${classes.subtitle}`]: {
        fontSize: theme.spacing(1.75),
        color: addOpacity(theme.palette.text.primary, 0.7)
    }
}));

interface IProps {
    icon?: string;
    title: string;
    subtitle: string;
    onClick?: () => void;
}

export const ActionItem: React.FC<IProps> = React.memo(({ icon, title, subtitle, onClick }) => (
    <StyledBox onClick={onClick} className={clsx({ [classes.clickable]: !!onClick })}>
        {icon && <LineIcon fontSize={30} name={icon} />}
        <Box marginLeft={1.5} marginRight="auto">
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.subtitle}>{subtitle}</Typography>
        </Box>
        {onClick && <ArrowForwardIosIcon fontSize="small" />}
    </StyledBox>
));
